import React from "react";

const AboutPage = () => (
  <div>
    <h2>About</h2>
    <p>This is the About page</p>
  </div>
);

export default AboutPage;